import mapToCorrectShippingAddress from '../../components/ReturnMethodSidebar/lib/mapToCorrectShippingAddress';
import DEFAULT_COPY from '../../constants/defaultCopy';
import { ADDRESS_VALIDATION } from '../../constants/endpoints';
import { receiveStoreLocatorGeolocation } from '../storeLocator';

export const RECEIVE_NOTIFICATION_MESSAGE = 'RECEIVE_NOTIFICATION_MESSAGE';
export const RECEIVE_ORDER_DATA_ADDRESSES = 'RECEIVE_ORDER_DATA_ADDRESSES';
export const RECEIVE_SHIPPING_ADDRESS = 'RECEIVE_SHIPPING_ADDRESS';
export const SET_SHIPPING_ADDRESS_VALIDATION = 'SET_SHIPPING_ADDRESS_VALIDATION';
export const SET_USER_SHIPPING_ADDRESS = 'SET_USER_SHIPPING_ADDRESS';
export const SET_USER_VALIDATION = 'SET_USER_VALIDATION';
export const SET_COLLECT_GIFT_ADDRESS = 'SET_COLLECT_GIFT_ADDRESS';
export const SET_IS_VALID_ADDRESS = 'SET_IS_VALID_ADDRESS';
export const SET_SHIPPING_ADDRESS_FORM_INVALID = 'SET_SHIPPING_ADDRESS_FORM_INVALID';

const formatAddress = (addressInfo) =>
  addressInfo
    ? {
        ...addressInfo.address,
        customer_name: addressInfo.customer_name || '',
      }
    : {};

export const receiveNotificationMessage = (notificationMsg) => ({
  type: RECEIVE_NOTIFICATION_MESSAGE,
  data: {
    notificationMsg,
  },
});

export const receiveOrderDataAddresses = (addressMap) => (dispatch, getState) => {
  const {
    page: { giftOrder },
  } = getState();

  const addressHierarchy = giftOrder
    ? ['shipTo', 'customerInfo']
    : ['billTo', 'shipTo', 'customerInfo'];

  const defaultAddressKey = addressHierarchy.reduce((finalKey, addressKey) => {
    const addressInfo = addressMap[addressKey];
    const hasAddress = addressInfo && addressInfo.address && addressInfo.address.zip;
    return hasAddress ? addressKey : finalKey;
  }, addressHierarchy[0]);

  const data = {
    shipTo: formatAddress(addressMap.shipTo),
    billTo: formatAddress(addressMap.billTo),
    customerInfo: formatAddress(addressMap.customerInfo),
    defaultAddressKey,
  };

  dispatch({
    type: RECEIVE_ORDER_DATA_ADDRESSES,
    data,
  });

  dispatch(
    receiveStoreLocatorGeolocation({
      postalCode: data[defaultAddressKey].zip,
      country: data[defaultAddressKey].country,
    }),
  );
};

export const receiveShippingAddress = (shippingAddress) => ({
  type: RECEIVE_SHIPPING_ADDRESS,
  data: {
    shippingAddress,
  },
});

export const setShippingAddressValidation = (isShippingAddressValid) => ({
  type: SET_SHIPPING_ADDRESS_VALIDATION,
  data: {
    isShippingAddressValid,
  },
});

export const updateUserShippingAddress = ({ userShippingAddress }) => ({
  type: SET_USER_SHIPPING_ADDRESS,
  data: {
    userShippingAddress,
  },
});

const setUserValidation = (initialShippingAddressFormValidation) => ({
  type: SET_USER_VALIDATION,
  data: {
    initialShippingAddressFormValidation,
  },
});

export const validateAddress = () => async (dispatch, getState) => {
  const {
    page: { countryCode, languageCode },
    addresses: { userShippingAddress } = {},
    language,
    page: { browserFingerprint } = {},
  } = getState();
  const { [languageCode]: DEFAULT_LANG_COPY = {} } = DEFAULT_COPY;
  try {
    // Prevent validation outside of US
    if (countryCode !== 'US') {
      dispatch(
        receiveShippingAddress(
          mapToCorrectShippingAddress(userShippingAddress, userShippingAddress),
        ),
      );
      dispatch(setShippingAddressValidation(true));
      return true;
    }
    const response = await fetch(ADDRESS_VALIDATION, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'narvar-tfid': browserFingerprint,
      },
      body: JSON.stringify({
        address: {
          ...userShippingAddress,
          country: userShippingAddress.country || countryCode,
        },
      }),
    });
    const { address, status } = await response.json();
    dispatch(setUserValidation(false));
    if (status !== 'SUCCESS') {
      const messagesWithPrompt =
        language['returns.step_2.shipping_form_address_validation_error'] ||
        DEFAULT_LANG_COPY['returns.step_2.shipping_form_address_validation_error'];
      dispatch(receiveNotificationMessage(messagesWithPrompt));
      dispatch(setShippingAddressValidation(false));
      return false;
    }
    dispatch(receiveShippingAddress(mapToCorrectShippingAddress(userShippingAddress, address)));
    dispatch(setShippingAddressValidation(true));
    return true;
  } catch (e) {
    dispatch(setShippingAddressValidation(false));
    dispatch(setUserValidation(false));
    dispatch(receiveNotificationMessage(`Address Validation: ${e}`));
    return false;
  }
};

export const setIsValidAddress = (isValidAddress) => ({
  type: SET_IS_VALID_ADDRESS,
  data: {
    isValidAddress,
  },
});

export const setShippingAddressFormInvalid = (hasInvalidShippingAddressForm) => ({
  type: SET_SHIPPING_ADDRESS_FORM_INVALID,
  data: {
    hasInvalidShippingAddressForm,
  },
});
